import {
  DoorStickerTemplate,
  FlyerTemplate,
  PolygraphyProductType,
  StickerTemplate,
} from '../../../../../../../services/exports/Constants';

export default {
  title: 'Produtos de impressão',
  types: {
    [PolygraphyProductType.Flyer]: {
      name: 'Flyers',
      templates: {
        [FlyerTemplate.One]: '#1 🆕',
        [FlyerTemplate.Two]: '#2  🆕',
        [FlyerTemplate.Three]: '#3',
        [FlyerTemplate.Four]: '#4',
      },
    },
    [PolygraphyProductType.Sticker]: {
      name: 'Autocolantes',
      templates: {
        [StickerTemplate.One]: '#1 🆕',
      },
    },
    [PolygraphyProductType.DoorSticker]: {
      name: 'Autocolantes de porta',
      templates: {
        [DoorStickerTemplate.One]: '#1 🆕',
        [DoorStickerTemplate.Two]: '#2 🆕',
      },
    },
    [PolygraphyProductType.Custom]: {
      name: 'Produtos de impressão personalizados',
    },
  },
  buttons: {
    order: 'Nova encomenda',
  },
  toasts: {
    failed_to_load_data: 'Falha ao carregar os dados',
  },
};
